import React from 'react';
import tudImage from '/tud.svg';

interface ModalProps {
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="modal modal-open">
        <div className="modal-box w-10/12 bg-[#000000] text-white bg-[url('/bg-modal.png')] bg-cover bg-center border-[#50A8EB] border-[1px]">
          <div className="flex justify-center mb-4">
            {/* <div className="bg-blue-500 rounded-full w-12 h-12 flex items-center justify-center">
              <span className="text-xl">T</span>
            </div> */}

            <img src={tudImage} alt="TUD" className="w-20 h-20" />
          </div>
          <h2 className="text-3xl font-bold mb-2 text-center">Congrats!</h2>
          <p className="mb-4 text-center text-md">You have been earned<br />+60 TUD Tokens</p>
          <div className="modal-action justify-center w-full">
            <button className="btn bg-[#50A8EB] text-white w-full" onClick={onClose}>Continue</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
